import { render, staticRenderFns } from "./EfsMdArchivesList.vue?vue&type=template&id=8475f628&scoped=true&"
import script from "./EfsMdArchivesList.vue?vue&type=script&lang=js&"
export * from "./EfsMdArchivesList.vue?vue&type=script&lang=js&"
import style0 from "./EfsMdArchivesList.vue?vue&type=style&index=0&id=8475f628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8475f628",
  null
  
)

export default component.exports